<template>
    <FeaturesWithMedia
        class="slice slice-features slice-features--with-video"
        :slice="props.slice"
        variation-modifier="with-video"
        default-anchor-id="features-with-video"
        :reverse="props.slice.primary.reverse"
    >
        <MuiVideoWrapperWithShapes
            enable-full-screen
            enable-scale-on-hover
            :is-fullscreen-loading="!isVideoLoaded"
            :theme="props.slice.primary.theme"
        >
            <MktVideoPlayer ref="videoPlayer" :src="videoSrc" />
            <template #fullscreen>
                <MktVideoPlayer :src="videoSrc" @videoplayer:loaded="onVideoLoaded" @videoplayer:before-unload="onVideoBeforeUnload" />
            </template>
        </MuiVideoWrapperWithShapes>
    </FeaturesWithMedia>
</template>

<script setup lang="ts">
    import {computed, ref} from 'vue';
    import {getSliceComponentProps} from '@prismicio/vue';

    import type {FeaturesSlice} from '@prismicio-types';
    import {MktVideoPlayer, MuiVideoWrapperWithShapes} from '#components';
    import {useVideoEmbedPlayer} from '../../../composables/useVideoEmbedPlayer';
    import FeaturesWithMedia from '../components/FeaturesWithMedia.vue';

    type FeaturesWithVideoInZone = Extract<FeaturesSlice, {variation: 'featuresWithVideo'}>;

    const props = defineProps(getSliceComponentProps<FeaturesWithVideoInZone>());

    const {getEmbedSrc} = useVideoEmbedPlayer();

    const videoSrc = computed(() => {
        const src = getEmbedSrc(props.slice.primary.video);
        if (!src) return '';
        return src.includes('?') ? `${src}&rel=0` : `${src}?rel=0`;
    });

    const {isVideoLoaded, onVideoLoaded, onVideoBeforeUnload} = videoStatus();

    function videoStatus() {
        const isVideoLoaded = ref(false);

        function onVideoLoaded() {
            isVideoLoaded.value = true;
        }

        function onVideoBeforeUnload() {
            isVideoLoaded.value = false;
        }

        return {
            isVideoLoaded,
            onVideoLoaded,
            onVideoBeforeUnload,
        };
    }
</script>
<style lang="scss">
    .slice-features--with-video {
        .video-player {
            max-width: 100%;
            max-height: 100%;
        }
    }
</style>
